import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Facebook, Twitter, Linkedin, Instagram } from "lucide-react";
import "../styles/components.css";

const Footer = () => {
    return (
        <footer style={{
            backgroundColor: 'var(--color-text)',
            color: 'var(--color-surface)',
            paddingTop: 'var(--spacing-3xl)',
            paddingBottom: 'var(--spacing-xl)',
            marginTop: 'var(--spacing-4xl)'
        }}>
            <Container className="container-custom">
                <Row className="g-4">
                    {/* À propos */}
                    <Col lg={4} md={6}>
                        <h4 style={{
                            fontSize: 'var(--font-size-lg)',
                            fontWeight: 'var(--font-weight-semibold)',
                            marginBottom: 'var(--spacing-lg)',
                            color: 'var(--color-surface)'
                        }}>
                            Moov4Goods
                        </h4>
                        <p style={{
                            fontSize: 'var(--font-size-sm)',
                            lineHeight: 'var(--line-height-relaxed)',
                            color: 'rgba(255, 255, 255, 0.8)',
                            marginBottom: 'var(--spacing-lg)'
                        }}>
                            Votre partenaire pour la gestion, la valorisation et le recyclage de vos biens et déchets. 
                            Nous accompagnons les particuliers, entreprises et collectivités dans leur transition écologique.
                        </p>
                    </Col>

                    {/* Liens rapides */}
                    <Col lg={2} md={6}>
                        <h5 style={{
                            fontSize: 'var(--font-size-base)',
                            fontWeight: 'var(--font-weight-semibold)',
                            marginBottom: 'var(--spacing-md)',
                            color: 'var(--color-surface)'
                        }}>
                            Navigation
                        </h5>
                        <ul style={{
                            listStyle: 'none',
                            padding: 0,
                            margin: 0
                        }}>
                            <li style={{ marginBottom: '0.5rem' }}>
                                <Link 
                                    to="/" 
                                    style={{
                                        color: 'rgba(255, 255, 255, 0.8)',
                                        textDecoration: 'none',
                                        fontSize: 'var(--font-size-sm)',
                                        transition: 'var(--transition-base)'
                                    }}
                                    onMouseEnter={(e) => e.target.style.color = 'var(--color-secondary)'}
                                    onMouseLeave={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.8)'}
                                >
                                    Accueil
                                </Link>
                            </li>
                            <li style={{ marginBottom: '0.5rem' }}>
                                <Link 
                                    to="/particuliers" 
                                    style={{
                                        color: 'rgba(255, 255, 255, 0.8)',
                                        textDecoration: 'none',
                                        fontSize: 'var(--font-size-sm)',
                                        transition: 'var(--transition-base)'
                                    }}
                                    onMouseEnter={(e) => e.target.style.color = 'var(--color-secondary)'}
                                    onMouseLeave={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.8)'}
                                >
                                    Particuliers
                                </Link>
                            </li>
                            <li style={{ marginBottom: '0.5rem' }}>
                                <Link 
                                    to="/professionnels" 
                                    style={{
                                        color: 'rgba(255, 255, 255, 0.8)',
                                        textDecoration: 'none',
                                        fontSize: 'var(--font-size-sm)',
                                        transition: 'var(--transition-base)'
                                    }}
                                    onMouseEnter={(e) => e.target.style.color = 'var(--color-secondary)'}
                                    onMouseLeave={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.8)'}
                                >
                                    Professionnels
                                </Link>
                            </li>
                            <li style={{ marginBottom: '0.5rem' }}>
                                <Link 
                                    to="/apropos" 
                                    style={{
                                        color: 'rgba(255, 255, 255, 0.8)',
                                        textDecoration: 'none',
                                        fontSize: 'var(--font-size-sm)',
                                        transition: 'var(--transition-base)'
                                    }}
                                    onMouseEnter={(e) => e.target.style.color = 'var(--color-secondary)'}
                                    onMouseLeave={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.8)'}
                                >
                                    À propos
                                </Link>
                            </li>
                            <li style={{ marginBottom: '0.5rem' }}>
                                <Link 
                                    to="/contact" 
                                    style={{
                                        color: 'rgba(255, 255, 255, 0.8)',
                                        textDecoration: 'none',
                                        fontSize: 'var(--font-size-sm)',
                                        transition: 'var(--transition-base)'
                                    }}
                                    onMouseEnter={(e) => e.target.style.color = 'var(--color-secondary)'}
                                    onMouseLeave={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.8)'}
                                >
                                    Contact
                                </Link>
                            </li>
                        </ul>
                    </Col>

                    {/* Contact */}
                    <Col lg={3} md={6}>
                        <h5 style={{
                            fontSize: 'var(--font-size-base)',
                            fontWeight: 'var(--font-weight-semibold)',
                            marginBottom: 'var(--spacing-md)',
                            color: 'var(--color-surface)'
                        }}>
                            Contact
                        </h5>
                        <ul style={{
                            listStyle: 'none',
                            padding: 0,
                            margin: 0
                        }}>
                            <li style={{
                                display: 'flex',
                                alignItems: 'flex-start',
                                marginBottom: 'var(--spacing-md)',
                                fontSize: 'var(--font-size-sm)',
                                color: 'rgba(255, 255, 255, 0.8)'
                            }}>
                                <Mail size={18} style={{ marginRight: '0.5rem', marginTop: '0.125rem', flexShrink: 0 }} />
                                <a 
                                    href="mailto:contact@moov4goods.fr"
                                    style={{
                                        color: 'rgba(255, 255, 255, 0.8)',
                                        textDecoration: 'none',
                                        transition: 'var(--transition-base)'
                                    }}
                                    onMouseEnter={(e) => e.target.style.color = 'var(--color-secondary)'}
                                    onMouseLeave={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.8)'}
                                >
                                    contact@moov4goods.fr
                                </a>
                            </li>
                            <li style={{
                                display: 'flex',
                                alignItems: 'flex-start',
                                marginBottom: 'var(--spacing-md)',
                                fontSize: 'var(--font-size-sm)',
                                color: 'rgba(255, 255, 255, 0.8)'
                            }}>
                                <Phone size={18} style={{ marginRight: '0.5rem', marginTop: '0.125rem', flexShrink: 0 }} />
                                <a href="tel:+33612096424" style={{ color: 'rgba(255, 255, 255, 0.8)', textDecoration: 'none', transition: 'var(--transition-base)' }} onMouseEnter={(e) => e.target.style.color = 'var(--color-secondary)'} onMouseLeave={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.8)'}>
                                    +33 6 12 09 64 24
                                </a>
                            </li>
                            <li style={{
                                display: 'flex',
                                alignItems: 'flex-start',
                                marginBottom: 'var(--spacing-md)',
                                fontSize: 'var(--font-size-sm)',
                                color: 'rgba(255, 255, 255, 0.8)'
                            }}>
                                <MapPin size={18} style={{ marginRight: '0.5rem', marginTop: '0.125rem', flexShrink: 0 }} />
                                <span>9 bis rue Gallieni, France</span>
                            </li>
                        </ul>
                    </Col>

                    {/* Réseaux sociaux */}
                    <Col lg={3} md={6}>
                        <h5 style={{
                            fontSize: 'var(--font-size-base)',
                            fontWeight: 'var(--font-weight-semibold)',
                            marginBottom: 'var(--spacing-md)',
                            color: 'var(--color-surface)'
                        }}>
                            Suivez-nous
                        </h5>
                        <div style={{
                            display: 'flex',
                            gap: 'var(--spacing-md)',
                            marginBottom: 'var(--spacing-lg)'
                        }}>
                            <button
                                type="button"
                                aria-label="Facebook"
                                style={{
                                    color: 'rgba(255, 255, 255, 0.8)',
                                    transition: 'var(--transition-base)',
                                    background: 'none',
                                    border: 'none',
                                    padding: 0,
                                    cursor: 'pointer'
                                }}
                                onMouseEnter={(e) => e.target.style.color = 'var(--color-secondary)'}
                                onMouseLeave={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.8)'}
                            >
                                <Facebook size={24} />
                            </button>
                            <button
                                type="button"
                                aria-label="Twitter"
                                style={{
                                    color: 'rgba(255, 255, 255, 0.8)',
                                    transition: 'var(--transition-base)',
                                    background: 'none',
                                    border: 'none',
                                    padding: 0,
                                    cursor: 'pointer'
                                }}
                                onMouseEnter={(e) => e.target.style.color = 'var(--color-secondary)'}
                                onMouseLeave={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.8)'}
                            >
                                <Twitter size={24} />
                            </button>
                            <button
                                type="button"
                                aria-label="LinkedIn"
                                style={{
                                    color: 'rgba(255, 255, 255, 0.8)',
                                    transition: 'var(--transition-base)',
                                    background: 'none',
                                    border: 'none',
                                    padding: 0,
                                    cursor: 'pointer'
                                }}
                                onMouseEnter={(e) => e.target.style.color = 'var(--color-secondary)'}
                                onMouseLeave={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.8)'}
                            >
                                <Linkedin size={24} />
                            </button>
                            <button
                                type="button"
                                aria-label="Instagram"
                                style={{
                                    color: 'rgba(255, 255, 255, 0.8)',
                                    transition: 'var(--transition-base)',
                                    background: 'none',
                                    border: 'none',
                                    padding: 0,
                                    cursor: 'pointer'
                                }}
                                onMouseEnter={(e) => e.target.style.color = 'var(--color-secondary)'}
                                onMouseLeave={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.8)'}
                            >
                                <Instagram size={24} />
                            </button>
                        </div>
                    </Col>
                </Row>

                {/* Copyright */}
                <Row style={{ marginTop: 'var(--spacing-3xl)', paddingTop: 'var(--spacing-xl)', borderTop: '1px solid rgba(255, 255, 255, 0.1)' }}>
                    <Col>
                        <p style={{
                            margin: 0,
                            textAlign: 'center',
                            fontSize: 'var(--font-size-sm)',
                            color: 'rgba(255, 255, 255, 0.6)'
                        }}>
                            © {new Date().getFullYear()} Moov4Goods | Tous droits réservés | 
                            <Link 
                                to="/contact" 
                                style={{
                                    color: 'rgba(255, 255, 255, 0.6)',
                                    textDecoration: 'none',
                                    marginLeft: '0.5rem',
                                    transition: 'var(--transition-base)'
                                }}
                                onMouseEnter={(e) => e.target.style.color = 'var(--color-secondary)'}
                                onMouseLeave={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.6)'}
                            >
                                Contact
                            </Link>
                        </p>
                    </Col>
                </Row>
            </Container>
        </footer>
    );
};

export default Footer;
